var PlanTarget = {
	firstMark: true,

	mark: function(x, y) {
		if (PlanTarget.node != undefined) PlanTarget.node.remove();
		
		PlanTarget.node = $("<img src='assets/crosshair.png' id='crosshair'>");
		$("#plan-points").append(PlanTarget.node);

		PlanTarget.node.css("left", (x * Plan.scale - 32) + "px")
		PlanTarget.node.css("top", (y * Plan.scale - 32) + "px")
	}
}